import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-slate-900 border-y border-slate-800" data-id="element-108">
      <div className="container mx-auto px-4 text-center" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-slate-950/80 rounded-3xl p-8 md:p-12 shadow-2xl border border-slate-600/50" data-id="element-110">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-slate-800/50 text-slate-300 mb-6 border border-slate-600/50" data-id="element-111">
            <ShieldCheck className="w-10 h-10" data-id="element-112" />
          </div>

          <h2 className="text-3xl font-extrabold text-white mb-4" data-id="element-113">
            🛡️ GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <p className="text-lg text-slate-300 mb-6" data-id="element-114">
            Tu inversión está 100% protegida. Abrí los 4 tomos. Revisá los 4
            bonos. Usalos en tu clase más difícil esta semana.
          </p>

          <div className="bg-slate-800/50 text-slate-200 font-bold text-xl py-4 px-6 rounded-xl mb-6 border border-slate-600/50" data-id="element-115">
            Si sentís que tus alumnos no respondieron mejor, o que el material
            no te ahorró horas: te devolvemos el 100% de tu dinero.
          </div>

          <p className="text-sm text-slate-400 font-medium uppercase tracking-wider" data-id="element-116">
            Sin preguntas, sin formularios, sin complicaciones.
          </p>
        </motion.div>
      </div>
    </section>;
}